import React, { Fragment, useState, useEffect } from 'react';
import Page from '../../Page';
import { ID_IMPRESSUM_PAGE } from '../../../css-api';
import { getLocale } from '../../../selectors/router';
import { useSelector } from 'react-redux';
import ImpressumText_de from './impressum_de';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  main: {
    padding: '2em 2em 4em',
    background: '#f1f1f1',
  },
}));

const Impressum = () => {
  const classes = useStyles();
  const [ImpressumText, setImpressumText] = useState();
  let localeId = useSelector(getLocale);
  useEffect(() => {
    import(`./impressum_${localeId}.js`)
      .then((imp) => {
        setImpressumText(imp.default);
      })
      .catch(() => setImpressumText(ImpressumText_de));
  });
  return (
    <Fragment>
      <Page
        id={ID_IMPRESSUM_PAGE}
        alignSelf="center"
        localeId={localeId}
        classNames={classes.main}
      >
        {ImpressumText}
      </Page>
    </Fragment>
  );
};

export default Impressum;
